module.exports = __webpack_public_path__ + "static/img/shanghaiwei.f4f1d63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shanghaiwei.png
// module id = h6bV
// module chunks = 1